const callTriggerModal = (
  message,
  callback = () => null,
  tipo = 'success',
  Footer = null
) => {
  const provider = document.querySelector('#show-modal-provider');

  if (!provider)
    throw new Error(
      'para que esta função seja chamada TriggerModalContextProvider deve ser usada no App.js'
    );

  const event = new CustomEvent('show-modal', {
    bubbles: false,
    detail: {
      options: { message, callback, tipo, Footer },
    },
  });

  provider.dispatchEvent(event);
};

const success = (message, callback = () => null, Footer = null) =>
  callTriggerModal(message, callback, 'success', Footer);

const error = (message, callback = () => null, Footer = null) =>
  callTriggerModal(message, callback, 'error', Footer);

const warning = (message, callback = () => null, Footer = null) =>
  callTriggerModal(message, callback, 'warning', Footer);

const modal = { success, error, warning };
export default modal;
